import { IBoundingBox } from './IBoundingBox.js';
import { IVector3 } from './IVector3.js';
export class IBoundingSphere {
    constructor(position, radius) {
        return {
            position: position,
            radius: radius
        };
    }
    static to_bounding_box(bounding_sphere) {
        const r = new IVector3(bounding_sphere.radius);
        return new IBoundingBox(IVector3.subtract(bounding_sphere.position, r), IVector3.add(bounding_sphere.position, r));
    }
}
//# sourceMappingURL=IBoundingSphere.js.map